import { connect } from 'react-redux';
import { maxPrintColorsPopupSelector } from '../../../redux/logo-editing/logo-editing.selectors';
import { maxPrintColorsLimitPopupDispatcher } from '../../../redux/logo-editing/logo-editing.dispatchers';
import MaxPrintColorsLimitExceededPopup from './max-print-colors-limit-exceeded-popup';
export default connect(maxPrintColorsPopupSelector, maxPrintColorsLimitPopupDispatcher)(MaxPrintColorsLimitExceededPopup);